<template>
  <v-form ref="form" autocomplete="off" @submit.prevent="save">
    <v-row>

      <v-col cols="12" sm="6">
        <branch-combobox v-model="form.branch" :input-errors="inputErrors"/>
      </v-col>


      <v-col cols="12" sm="6">
        <branch-combobox v-model="form.branchDestination" :input-errors="inputErrors"/>
      </v-col>


      <v-col cols="12" sm="6">
        <stock-operation-combobox v-model="form.operation" :input-errors="inputErrors"/>
      </v-col>


      <v-col cols="12" sm="6">
        <v-text-field

            prepend-icon="description"
            name="reason"
            v-model="form.reason"
            :label="$t('delivery.stockTransaction.labels.reason')"
            :placeholder="$t('delivery.stockTransaction.labels.reason')"
            :error="hasInputErrors('reason')"
            :error-messages="getInputErrors('reason')"
            color="secondary"

        ></v-text-field>
      </v-col>


      <v-col cols="12" sm="6">
        <product-combobox v-model="form.items" :input-errors="inputErrors"/>
      </v-col>


      <v-col cols="12" sm="6">
        <user-combobox v-model="form.user" :input-errors="inputErrors"/>
      </v-col>

    </v-row>
  </v-form>
</template>

<script>

import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'

import BranchCombobox from "../../../../combobox/BranchCombobox";
import ProductCombobox from "../../../../combobox/ProductCombobox";
import {UserCombobox} from "@dracul/user-frontend";
import StockOperationCombobox from "../../../../combobox/StockOperationCombobox";


export default {
  name: "StockTransactionForm",
  mixins: [InputErrorsByProps, RequiredRule],
  components: {
    BranchCombobox,
    StockOperationCombobox,
    ProductCombobox,
    UserCombobox,
  },
  props: {
    value: {
      type: Object,
      required: true
    },
  },
  computed: {
    form: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    form: {
      handler(newVal) {
        this.$emit('input', newVal)
      },
      deep: true
    }
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    }
  },
  data() {
    return {}
  }
}
</script>

<style scoped>

</style>

